import Meta from '@/components/common/Meta'

import PersonalStorageSolutionsPage from '@/v2/components/pages/landing-pages/personal-storage-solutions-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/personal-storage-solutions-page'

interface PersonalStorageSolutionsPageProps {}

const Page: React.FC<PersonalStorageSolutionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.personal_storage_solutions.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.personal_storage_solutions?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.personal_storage_solutions?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <PersonalStorageSolutionsPage />
    </>
  )
}

export default Page
